import { BADGE_FOLDER } from './BadgeCard'

const RARITIES = [
  { key: 'common',    label: 'Common',    color: '#22C55E' },
  { key: 'rare',      label: 'Rare',      color: '#3B82F6' },
  { key: 'epic',      label: 'Epic',      color: '#F59E0B' },
  { key: 'legendary', label: 'Legendary', color: '#9333EA' },
]

const countByRarity = (earnedBadges) => {
  const counts = { common: 0, rare: 0, epic: 0, legendary: 0 }
  earnedBadges.forEach(b => {
    const folder = BADGE_FOLDER[b.badge_key] || 'common'
    counts[folder]++
  })
  return counts
}

const BadgeSummaryCard = ({ totalEarned, totalAvailable, allBadges, earnedBadges, recentBadge, onViewRecent }) => {
  const rarityCounts = countByRarity(earnedBadges)

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.6fr 1.2fr', gap: 16, marginBottom: 24 }}>

      {/* Total Badges */}
      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'linear-gradient(135deg,#EEF2FF,#DCE4FF)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src="/assets/icons/medal.png" alt="badge" style={{ width: 30, height: 30, objectFit: 'contain' }} />
          </div>
          <div>
            <p style={{ margin: 0, fontSize: 13, color: '#7A889B', fontWeight: 600 }}>Total Badges</p>
            <p style={{ margin: '4px 0 0', fontSize: 28, fontWeight: 900, color: '#0D2A4F', lineHeight: 1 }}>
              {totalEarned} <span style={{ fontSize: 18, color: '#B0BBC8', fontWeight: 700 }}>/ {totalAvailable}</span>
            </p>
          </div>
        </div>
      </div>

      {/* Rarity Breakdown */}
      <div style={cardStyle}>
        <p style={{ margin: '0 0 12px', fontSize: 13, fontWeight: 700, color: '#4F6BED' }}>Rarity Breakdown</p>
        <div style={{ display: 'flex', gap: 20 }}>
          {RARITIES.map(r => (
            <div key={r.key} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ width: 12, height: 12, borderRadius: '50%', background: r.color, display: 'inline-block', flexShrink: 0 }} />
              <span style={{ fontSize: 18, fontWeight: 800, color: '#0D2A4F' }}>{rarityCounts[r.key]}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Recently Earned */}
      <div style={cardStyle}>
        <p style={{ margin: '0 0 10px', fontSize: 13, fontWeight: 700, color: '#4F6BED' }}>Recently Earned</p>
        {recentBadge ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <img src={BADGE_IMG_MAP[recentBadge.badge_key] || '/assets/icons/medal.png'} alt={recentBadge.badge_name} style={{ width: 26, height: 26, objectFit: 'contain' }} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: '#0D2A4F', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{recentBadge.badge_name}</p>
              <p style={{ margin: '2px 0 0', fontSize: 11, color: '#7A889B' }}>Earned on {formatDate(recentBadge.earned_at)}</p>
            </div>
            <button
              onClick={onViewRecent}
              style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 700, color: '#4F6BED', flexShrink: 0 }}
            >
              View
            </button>
          </div>
        ) : (
          <p style={{ margin: 0, fontSize: 13, color: '#B0BBC8' }}>No badges yet</p>
        )}
      </div>

    </div>
  )
}

const cardStyle = {
  background: '#fff',
  border: '1px solid #E7ECF3',
  borderRadius: 18,
  padding: '16px 18px',
  boxShadow: '0 4px 16px rgba(13,42,79,.05)',
}

const BADGE_IMG_MAP = {
  first_lesson: '/assets/badges/common/first_lesson.png',
  '100_questions': '/assets/badges/rare/100_questions.png',
  '500_questions': '/assets/badges/epic/500_questions.png',
  '7day_streak': '/assets/badges/common/7day_streak.png',
  '30day_streak': '/assets/badges/legendary/30day_streak.png',
  review_hero: '/assets/badges/rare/review_hero.png',
  review_master: '/assets/badges/legendary/review_master.png',
  accuracy_80: '/assets/badges/rare/accuracy_80.png',
  accuracy_90: '/assets/badges/epic/accuracy_90.png',
  level_1_complete: '/assets/badges/epic/level_1_complete.png',
  level_3_complete: '/assets/badges/epic/level_3_complete.png',
  level_5_complete: '/assets/badges/epic/level_5_complete.png',
}

const formatDate = (dateStr) => {
  if (!dateStr) return ''
  try {
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
  } catch { return dateStr }
}

export default BadgeSummaryCard
